<template>
	<div class="text-white">
		<div class="container">
			<h2 class="mb-4 text-capitalize">You’re Almost There</h2>
			<div
				class="d-block cursor-pointer mb-5"
				@click="saveSurvey()"
				v-if="!savedSurvey"
			>
				<finalize-sections-ui>
					<template v-slot:image
						><img
							width="120"
							alt="save survey"
							class="img-fluid"
							:src="
								require(`@/assets/images/create-survey/save-survey-${tenantType}.svg`)
							"
					/></template>
					<template v-slot:title>Save Survey</template>
					<template v-slot:description
						>Let’s make this happen! Share the survey with your audience and get
						insights on your brand!</template
					>
				</finalize-sections-ui>
			</div>

			<transition name="fade">
				<div class="row" v-if="savedSurvey && !surveyIsPublished">
					<a class="col-6 d-block" :href="handlePreviewLink" target="_blank">
						<finalize-sections-ui>
							<template v-slot:image
								><img
									alt="preview survey"
									class="img-fluid"
									:src="
										require(`@/assets/images/create-survey/preview-${tenantType}.svg`)
									"
							/></template>
							<template v-slot:title>preview</template>
							<template v-slot:description>
								We get it, you can’t rush perfection! Save the survey for later
								review or refinement, it can be found in your saved
								surveys</template
							>
						</finalize-sections-ui>
					</a>
					<div
						class="col-6 d-block cursor-pointer"
						@click="publishSettingPopupStatus = true"
					>
						<finalize-sections-ui>
							<template v-slot:image
								><img
									alt="publish survey"
									class="img-fluid"
									:src="
										require(`@/assets/images/create-survey/publish-survey-${tenantType}.svg`)
									"
							/></template>
							<template v-slot:title>publish Survey</template>
							<template v-slot:description>
								Let’s make this happen! Share the survey with your audience and
								get insights on your brand!</template
							>
						</finalize-sections-ui>
					</div>
				</div>
			</transition>

			<transition name="fade">
				<div v-if="savedSurvey && surveyIsPublished">
					<finalize-sections-ui>
						<template v-slot:image
							><img
								alt="preview survey"
								class="img-fluid"
								:src="
									require(`@/assets/images/create-survey/publish-survey-${tenantType}.svg`)
								"
						/></template>
						<template v-slot:title>Copy Survey Link</template>
						<template v-slot:description>{{
							publishSurveyPopupValues.description
						}}</template>
						<template v-slot:copyLinkBody>
							<div class="copy-url-content">
								<div class="d-flex justify-content-between">
									<textarea
										:value="handlePreviewLink"
										class="link"
										readonly
										rows="2"
										cols="70"
										v-on:focus="$event.target.select()"
										ref="clone"
									></textarea>

									<span
										@click="copyURL()"
										class="copy-link cursor-pointer px-3 d-flex align-items-center"
									>
										<img
											alt="copy link"
											class="copy-link-icon me-2"
											height="40"
											src="@/assets/images/set-question/copy-link.svg"
											width="30"
										/>
										<span>Copy link URL</span>
									</span>
								</div>
							</div>
						</template>
					</finalize-sections-ui>
				</div>
			</transition>
		</div>

		<transition name="fade">
			<div
				v-if="saveSurveyPopupStatus"
				class="modal-layout position-fixed d-flex justify-content-center align-items-center"
			>
				<finalize-card-popup
					@close-popup="saveSurveyPopupStatus = false"
					:popup-values="savedSurveyPopupValues"
					:link="this.handlePreviewLink"
				></finalize-card-popup>
			</div>
		</transition>

		<transition name="fade">
			<div
				v-if="publishPopupStatus"
				class="modal-layout position-fixed d-flex justify-content-center align-items-center"
			>
				<finalize-card-popup
					@close-popup="publishPopupStatus = false"
					:popup-values="publishSurveyPopupValues"
					:link="this.handlePreviewLink"
				></finalize-card-popup>
			</div>
		</transition>

		<transition name="fade">
			<div
				v-if="publishSettingPopupStatus"
				class="modal-layout position-fixed d-flex justify-content-center align-items-center"
			>
				<publish-setting
					@close-popup="publishSettingPopupStatus = false"
					@publishEvent="publish"
				></publish-setting>
			</div>
		</transition>
	</div>
</template>

<script>
import FinalizeSectionsUi from "../ui/finalize-sections-ui";
import FinalizeCardPopup from "./finalize-card-popup.vue";
import { mapGetters } from "vuex";
import PublishSetting from "./publish-setting.vue";

export default {
	name: "Finalize",
	components: { FinalizeSectionsUi, FinalizeCardPopup, PublishSetting },
	data() {
		return {
			saveSurveyPopupStatus: false,
			publishSettingPopupStatus: false,
			publishPopupStatus: false,
			savedSurvey: false,
			surveyIsPublished: false,

			savedSurveyPopupValues: {
				ImgAlt: "Saved Surveys",
				btnText: "View Saved Surveys",
				color: "#3561EF",
				btnTextColor: "#fff",
				description:
					"A link has been created for your to send it to your colleagues or managers, copy the link address below",
				header: "Got it! Your Survey has Been Saved",
				imgUrl: "survey-is-saved",
			},
			publishSurveyPopupValues: {
				ImgAlt: "survey is created",
				btnText: "View Survey in Dashboard",
				color: "#FED700",
				btnTextColor: "#212121",
				description:
					"A link has been created for your to send it to your contacts, copy the link address below. Good luck!",
				header: "YAAY! Your Survey has Been successfully created",
				imgUrl: "survey-is-created",
			},
		};
	},
	computed: {
		...mapGetters("auth", {
			tenantType: "tenantType",
			subdomain: "subdomain",
		}),

		surveyCode() {
			return this.$store.getters["surveyJourney/surveyCode"];
		},

		handlePreviewLink() {
			return `https://${
				this.subdomain
			}.${this.tenantType.toLowerCase()}-ntsal.com/?code=${this.surveyCode}`;
		},

		tenantType() {
			return this.$store.getters["auth/tenantType"].toLowerCase();
		},
	},
	methods: {
		publish() {
			this.publishSettingPopupStatus = false;
			setTimeout(() => {
				this.publishPopupStatus = true;
				this.surveyIsPublished = true;
			});
		},
		saveSurvey() {
			try {
				this.$store.dispatch("surveyJourney/saveSurvey");
				this.saveSurveyPopupStatus = true;
				setTimeout(() => {
					this.savedSurvey = true;
				});
			} catch (error) {
				this.$store.dispatch("dialog/showErrorDialog", {
					error: error,
				});
			}
		},
		copyURL() {
			this.$refs.clone.focus();
			document.execCommand("copy");
		},
	},
};
</script>

<style lang="scss" scoped>
.content-box {
	@extend %background-grey-1-border-white-1;
	border-radius: $radius-44;
	color: $color-white;

	.sub-title {
		@extend %font-60-79-bold;
	}

	.description {
		@extend %font-26_28-regular;
	}
}
</style>
